export default __webpack_public_path__ + "static/media/building.7482a8cc.svg";